var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("form.success.headline")))]),_c('v-card-text',[_vm._v(_vm._s(_vm.$t("form.success.close")))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }